(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-color-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-color-accordion')) {
    customElements.define(
      'c-color-accordion',
      class CColorAccordion extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-item]')];
          this.photos = [...this.querySelectorAll('[data-photo]')];
          if (!this.items.length) return;
          this.hover = window.matchMedia('(hover: hover) and (min-width: 978px)');

          this.items.forEach((item, i) => {
            const row = item.querySelector('summary');
            // Keep one color open: clicking the open one doesn't collapse it.
            row.addEventListener('click', (e) => {
              e.preventDefault();
              this.open(i);
            });
            // Desktop hover, with a short intent delay so sweeping across the list doesn't flicker.
            row.addEventListener('mouseenter', () => {
              if (!this.hover.matches) return;
              clearTimeout(this.hoverTimer);
              this.hoverTimer = setTimeout(() => this.open(i), 120);
            });
            row.addEventListener('mouseleave', () => clearTimeout(this.hoverTimer));
            row.addEventListener('focus', () => { if (this.hover.matches) this.open(i); });

            const link = item.querySelector('[data-offer-value]');
            if (link) link.addEventListener('click', () => this.selectInOffer(link));
          });

          this.onBlockSelect = (e) => {
            const i = this.items.indexOf(e.target);
            if (i > -1) this.open(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          clearTimeout(this.hoverTimer);
        }

        open(index) {
          this.items.forEach((item, i) => { item.open = i === index; });
          this.photos.forEach((photo, i) => photo.classList.toggle('is-active', i === index));
        }

        selectInOffer(link) {
          // Only in-page links preselect the offer; full URLs just navigate.
          if (!link.getAttribute('href').startsWith('#')) return;
          document.dispatchEvent(new CustomEvent('c-product-offer:select', {
            detail: { option: this.dataset.offerOption || 'Color', value: link.dataset.offerValue },
          }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-color-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-color-story')) {
    customElements.define(
      'c-color-story',
      class CColorStory extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          if (!this.tabs.length) return;
          this.index = Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => { this.halt(); this.select(i); });
            tab.addEventListener('keydown', (e) => {
              const keys = { ArrowRight: 1, ArrowLeft: -1 };
              let next = null;
              if (e.key in keys) next = (i + keys[e.key] + this.tabs.length) % this.tabs.length;
              if (e.key === 'Home') next = 0;
              if (e.key === 'End') next = this.tabs.length - 1;
              if (next === null) return;
              e.preventDefault();
              this.halt();
              this.select(next);
              this.tabs[next].focus();
            });
          });
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.tabs.indexOf(e.target);
            if (i > -1) { this.halt(); this.select(i); }
          });

          // Autoplay: rotate the colors every few seconds. Pauses on hover, focus, touch and while off screen;
          // stops for good once the visitor picks a tab. Off with reduced motion.
          const seconds = Number(this.dataset.autoplay) || 0;
          if (seconds > 0 && this.tabs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.delay = seconds * 1000;
            this.paused = new Set();
            const pause = (reason) => { this.paused.add(reason); clearTimeout(this.timer); };
            const resume = (reason) => { this.paused.delete(reason); this.start(); };
            this.addEventListener('mouseenter', () => pause('hover'));
            this.addEventListener('mouseleave', () => resume('hover'));
            this.addEventListener('focusin', () => pause('focus'));
            this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) resume('focus'); });
            this.addEventListener('touchstart', () => pause('touch'), { passive: true });
            this.io = new IntersectionObserver(([entry]) => (entry.isIntersecting ? resume('offscreen') : pause('offscreen')));
            this.io.observe(this);
          }
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.io) this.io.disconnect();
        }

        start() {
          clearTimeout(this.timer);
          if (!this.delay || this.halted || this.paused.size) return;
          this.timer = setTimeout(() => {
            this.select((this.index + 1) % this.tabs.length);
            this.start();
          }, this.delay);
        }

        halt() {
          this.halted = true;
          clearTimeout(this.timer);
        }

        select(index) {
          this.index = index;
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !on;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-fabric-chooser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-fabric-chooser')) {
    customElements.define(
      'c-fabric-chooser',
      class CFabricChooser extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('.c-fabric-chooser__stage');
          if (!this.stage) return;
          this.panels = [...this.stage.querySelectorAll('.c-fabric-chooser__panel')];
          const hover = window.matchMedia('(hover: hover) and (min-width: 978px)');
          // Below 978px both fabrics are always open, so there is nothing to switch.
          const desktop = window.matchMedia('(min-width: 978px)');
          // Neutral start (setting 0): leaving the stage with the mouse, or tabbing out of it, closes the panel again.
          this.neutral = this.stage.hasAttribute('data-neutral');
          if (this.neutral) {
            this.stage.addEventListener('mouseleave', () => { if (hover.matches) this.activate(-1); });
            this.stage.addEventListener('focusout', (e) => { if (!this.stage.contains(e.relatedTarget)) this.activate(-1); });
          }
          this.panels.forEach((panel, i) => {
            panel.addEventListener('mouseenter', () => { if (hover.matches) this.activate(i); });
            panel.addEventListener('focusin', () => { if (desktop.matches) this.activate(i); });
            panel.addEventListener('click', (e) => { if (desktop.matches && !e.target.closest('a')) this.activate(i); });
          });
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.panels.indexOf(e.target.closest?.('.c-fabric-chooser__panel'));
            if (i > -1) this.activate(i);
          });
        }

        activate(index) {
          this.panels.forEach((panel, i) => {
            const on = i === index;
            panel.toggleAttribute('data-active', on);
            const btn = panel.querySelector('.c-fabric-chooser__name');
            if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
          this.stage.toggleAttribute('data-active-last', this.panels.length === 2 && index === 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-faq')) {
    customElements.define(
      'c-faq',
      class CFaq extends HTMLElement {
        connectedCallback() {
          if (this.dataset.multiple === 'true') return;
          this.items = [...this.querySelectorAll('details')];
          if (this.hasAttribute('data-animate')) return this.setupAnimated();
          this.items.forEach((d) => d.addEventListener('toggle', () => {
            if (d.open) this.items.forEach((o) => { if (o !== d) o.open = false; });
          }));
          document.addEventListener('shopify:block:select', (e) => {
            const d = e.target.querySelector && e.target.querySelector('details');
            if (d && this.contains(d)) d.open = true;
          });
        }

        // Divided style: the answer slides open/closed instead of jumping, one question at a time.
        setupAnimated() {
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.items.forEach((d) => {
            d.querySelector('summary').addEventListener('click', (e) => {
              e.preventDefault();
              const opening = !d.open || d.dataset.closing === 'true';
              if (opening) this.items.forEach((o) => { if (o !== d && o.open) this.animate(o, false); });
              this.animate(d, opening);
            });
          });
          document.addEventListener('shopify:block:select', (e) => {
            const d = e.target.querySelector && e.target.querySelector('details');
            if (d && this.contains(d) && !d.open) this.animate(d, true);
          });
        }

        animate(d, open) {
          const summary = d.querySelector('summary');
          const from = d.offsetHeight;
          if (d.anim) d.anim.cancel();
          if (open) d.open = true;
          d.dataset.closing = open ? 'false' : 'true';
          const to = open ? d.scrollHeight : summary.offsetHeight;
          const done = () => {
            d.anim = null;
            d.style.height = '';
            if (!open) d.open = false;
            delete d.dataset.closing;
          };
          if (this.reduced.matches) return done();
          d.anim = d.animate({ height: [`${from}px`, `${to}px`] }, { duration: 300, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
          d.anim.onfinish = done;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-feature-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-feature-timeline')) {
    customElements.define(
      'c-feature-timeline',
      class CFeatureTimeline extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.c-feature-timeline__list');
          if (!this.list) return;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.animate !== 'true' || reduced || window.Shopify?.designMode) return;
          this.steps = [...this.list.querySelectorAll('.c-feature-timeline__step')];
          this.raf = 0;
          this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => this.update()); };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          cancelAnimationFrame(this.raf);
        }

        update() {
          this.raf = 0;
          const r = this.list.getBoundingClientRect();
          const vh = window.innerHeight;
          // The zip follows a line at 60% of the viewport height through the list.
          const reach = Math.min(r.height, Math.max(0, vh * 0.6 - r.top));
          this.style.setProperty('--_progress', `${reach}px`);
          this.steps.forEach((step) => {
            const dot = step.querySelector('.c-feature-timeline__dot');
            const y = dot.getBoundingClientRect().top - r.top;
            step.toggleAttribute('data-active', reach >= y);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-hero')) {
    customElements.define(
      'c-hero',
      class CHero extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.slides = [...this.track.children];
          this.dots = [...this.querySelectorAll('.c-hero__dot')];
          this.index = 0;

          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.sync());
          }, { passive: true });

          const seconds = Number(this.dataset.autoplay) || 0;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (seconds > 0 && !reduce) {
            this.delay = seconds * 1000;
            this.paused = new Set();
            const pause = (reason) => { this.paused.add(reason); this.stop(); };
            const resume = (reason) => { this.paused.delete(reason); this.start(); };
            this.addEventListener('mouseenter', () => pause('hover'));
            this.addEventListener('mouseleave', () => resume('hover'));
            this.addEventListener('focusin', () => pause('focus'));
            this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) resume('focus'); });
            this.addEventListener('touchstart', () => pause('touch'), { passive: true });
            this.io = new IntersectionObserver(([entry]) => (entry.isIntersecting ? resume('offscreen') : pause('offscreen')));
            this.io.observe(this);
          }

          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1) { this.go(i, 'instant'); this.paused && this.paused.add('editor'); this.stop(); }
          });
        }

        disconnectedCallback() {
          this.stop();
          if (this.io) this.io.disconnect();
        }

        start() {
          this.stop();
          if (!this.delay || this.paused.size) return;
          this.timer = setTimeout(() => this.go((this.index + 1) % this.slides.length), this.delay);
        }

        stop() { clearTimeout(this.timer); }

        go(i, behavior) {
          this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: behavior || 'smooth' });
        }

        sync() {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i === this.index && this.timer) return;
          this.index = Math.max(0, Math.min(i, this.slides.length - 1));
          this.dots.forEach((d, n) => d.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
          if (this.delay) this.start();
        }
      }
    );
  }

  if (!customElements.get('c-hero-timer')) {
    customElements.define(
      'c-hero-timer',
      class CHeroTimer extends HTMLElement {
        connectedCallback() {
          this.output = this.querySelector('[data-time]');
          this.seconds = Number(this.dataset.seconds) || 60;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.output || this.dataset.animate !== 'true' || reduce || window.Shopify?.designMode) return;

          this.video = this.closest('c-hero')?.querySelector('.c-hero__media video');
          this.tick = this.tick.bind(this);
          this.start = performance.now();
          this.visible = false;
          // The number changes once a second, so 4 checks a second is plenty (and stops off screen).
          this.io = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible && !this.timer) this.tick();
          });
          this.io.observe(this);
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          clearTimeout(this.timer);
        }

        // With a playing video: full count at its start, 0:00 at its end, restarting as it loops.
        // Without one: one second per second, holding on 0:00 for 2s before starting over.
        remaining() {
          const v = this.video;
          if (v && v.duration > 0 && v.offsetParent !== null) {
            return Math.ceil(this.seconds * (1 - v.currentTime / v.duration));
          }
          const cycle = (this.seconds + 2) * 1000;
          const elapsed = ((performance.now() - this.start) % cycle) / 1000;
          return Math.max(0, this.seconds - Math.floor(elapsed));
        }

        tick() {
          this.timer = 0;
          if (!this.visible) return;
          const s = Math.min(this.seconds, Math.max(0, this.remaining()));
          const text = `0:${String(s).padStart(2, '0')}`;
          if (this.output.textContent !== text) this.output.textContent = text;
          this.timer = setTimeout(this.tick, 250);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-hotspots')) {
    customElements.define(
      'c-hotspots',
      class CHotspots extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('[data-stage]');
          this.pins = [...this.querySelectorAll('[data-pin]')];
          this.cards = [...this.querySelectorAll('[data-card]')];
          if (!this.stage || !this.pins.length) return;

          this.index = 0;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.hasAttribute('data-autoplay') && !this.reduced && this.pins.length > 1;
          if (!this.autoplay) this.removeAttribute('data-autoplay');
          this.hover = window.matchMedia('(hover: hover) and (min-width: 978px)');

          this.pins.forEach((pin, i) => {
            pin.addEventListener('click', () => this.activate(i));
            pin.addEventListener('focus', () => this.activate(i));
            pin.addEventListener('mouseenter', () => { if (this.hover.matches) this.activate(i); });
          });

          // Hovering or focusing the photo holds the current card (and its progress bar).
          this.stage.addEventListener('mouseenter', () => this.setPaused(true));
          this.stage.addEventListener('mouseleave', () => this.setPaused(false));
          this.stage.addEventListener('focusin', () => this.setPaused(true));
          this.stage.addEventListener('focusout', (e) => { if (!this.stage.contains(e.relatedTarget)) this.setPaused(false); });

          // The progress bar is the timer: when it fills, move to the next pin.
          this.cards.forEach((card) => {
            const bar = card.querySelector('[data-bar]');
            if (bar) bar.addEventListener('animationend', () => { if (this.autoplay) this.activate((this.index + 1) % this.pins.length, true); });
          });

          this.onBlockSelect = (e) => {
            const i = this.pins.findIndex((pin) => pin.closest('[data-shopify-editor-block]') === e.target);
            if (i > -1) { this.activate(i); this.setPaused(true); }
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          // Entrance + autoplay only start once the section is on screen.
          this.classList.add('is-ready');
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-inview');
              this.startTimer();
              this.io.disconnect();
            });
          }, { threshold: 0.25 });
          this.io.observe(this);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.io) this.io.disconnect();
        }

        activate(index, fromTimer) {
          if (index === this.index && !fromTimer) return;
          this.index = index;
          this.pins.forEach((pin, i) => pin.setAttribute('aria-expanded', i === index ? 'true' : 'false'));
          this.cards.forEach((card, i) => { card.hidden = i !== index; });
          this.startTimer();
        }

        startTimer() {
          if (!this.autoplay) return;
          this.cards.forEach((card) => card.classList.remove('is-timing'));
          const card = this.cards[this.index];
          if (!card) return;
          void card.offsetWidth; // restart the bar's animation
          card.classList.add('is-timing');
        }

        setPaused(paused) {
          this.classList.toggle('is-paused', paused);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-listicle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-listicle')) {
    customElements.define(
      'c-listicle',
      class CListicle extends HTMLElement {
        connectedCallback() {
          this.reasons = [...this.querySelectorAll('[data-reason]')];
          this.media = this.reasons.map((r) => r.querySelector('[data-media]'));
          this.frame = this.querySelector('[data-frame]');
          this.active = -1;
          this.raf = 0;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.desktop = window.matchMedia('(width >= 978px)');
          if (this.reduced.matches) this.usePosters();

          this.onScroll = () => {
            if (!this.raf) this.raf = requestAnimationFrame(() => this.tick());
          };
          this.onMode = () => this.setMode();
          this.desktop.addEventListener('change', this.onMode);
          this.reduced.addEventListener('change', this.onMode);
          window.addEventListener('resize', this.onScroll);

          this.onBlockSelect = (e) => {
            const i = this.reasons.indexOf(e.target);
            if (i < 0) return;
            // Staged mode activates from scroll geometry as the block lands; reveal mode needs nothing.
            this.reasons[i].scrollIntoView({ block: 'center', behavior: this.reduced.matches ? 'auto' : 'smooth' });
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.setMode();
        }

        disconnectedCallback() {
          this.teardown();
          this.desktop.removeEventListener('change', this.onMode);
          this.reduced.removeEventListener('change', this.onMode);
          window.removeEventListener('resize', this.onScroll);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        // ----- Modes: staged (desktop), reveal (mobile), static (reduced motion / no stage) -----
        setMode() {
          this.teardown();
          if (this.reduced.matches) {
            this.media.forEach((m) => this.load(m));
            return;
          }
          if (this.frame && this.desktop.matches && this.dataset.effect === 'stage') this.stage();
          else this.reveal();
        }

        teardown() {
          if (this.io) this.io.disconnect();
          if (this.sectionIo) this.sectionIo.disconnect();
          this.io = null;
          this.sectionIo = null;
          window.removeEventListener('scroll', this.onScroll);
          cancelAnimationFrame(this.raf);
          this.raf = 0;
          if (this.classList.contains('is-staged')) {
            // Put each media back in its own reason (static layout).
            this.media.forEach((m, i) => {
              m.removeAttribute('data-state');
              m.style.removeProperty('--_p');
              this.reasons[i].prepend(m);
            });
          }
          this.classList.remove('is-staged', 'is-armed');
          this.reasons.forEach((r) => r.classList.remove('is-active', 'is-in'));
          this.pauseAll();
          this.active = -1;
        }

        // Desktop: move every media into the sticky frame and follow the reason under the middle line.
        stage() {
          this.media.forEach((m, i) => {
            if (i > 1) this.defer(m);
            this.frame.appendChild(m);
          });
          this.classList.add('is-staged');
          this.measure();

          // The active reason is derived from scroll geometry in tick() on every frame rather than
          // from an IntersectionObserver on a zero-height root: that one could miss a reason on a
          // fast scroll (notably Safari) and leave the media/counter behind the copy. Geometry
          // self-corrects on the next frame, whatever happened in between.
          this.sectionIo = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
              this.media.forEach((m) => this.load(m));
              window.addEventListener('scroll', this.onScroll, { passive: true });
              this.play(this.media[this.active]);
              this.tick();
            } else {
              window.removeEventListener('scroll', this.onScroll);
              this.pauseAll();
            }
          });
          this.sectionIo.observe(this);
          this.activate(0);
        }

        // The stage sits under the theme's sticky header and is vertically centered when it fits.
        measure() {
          const header = document.querySelector('.section-header');
          const headerH = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
          const room = window.innerHeight - headerH;
          const stageH = Math.min(602, room - 48);
          const stageTop = headerH + Math.max(24, (room - stageH) / 2);
          this.style.setProperty('--_stage-h', `${stageH}px`);
          this.style.setProperty('--_stage-top', `${stageTop}px`);
          // The sticky stage shares the list's grid row and releases when the row's bottom reaches
          // stageTop + stageH + 64 (its bottom margin). Reasons 1-4 keep scrolling under it because
          // the next reason's copy fills the column; the last one has nothing after it, so any
          // extra room there is an empty gap with the copy climbing above the media. Pad the list
          // only as much as it takes for the last reason's (centered) copy to be level with the
          // media at the exact release point — from there the two scroll away together.
          // At release the list bottom sits at stageTop + stageH + 64 and we want the copy's center
          // at stageTop + stageH / 2, so the gap between the two must be stageH / 2 + 64; whatever
          // the last row already provides below its copy comes off the tail.
          const last = this.reasons[this.reasons.length - 1];
          const body = last && last.querySelector('.c-listicle__body');
          let tail = 0;
          if (last && body) {
            const rowBottom = last.getBoundingClientRect().bottom;
            const bodyRect = body.getBoundingClientRect();
            const below = rowBottom - (bodyRect.top + bodyRect.height / 2);
            tail = Math.max(0, Math.round(stageH / 2 + 64 - below));
          }
          this.style.setProperty('--_tail', `${tail}px`);
        }

        activate(i) {
          if (i === this.active || i < 0) return;
          const prev = this.active;
          this.active = i;
          if (this.frame) this.frame.dataset.dir = prev > i ? 'up' : 'down';
          this.reasons.forEach((r, n) => r.classList.toggle('is-active', n === i));

          if (this.classList.contains('is-staged')) {
            // Snap the incoming media to the start edge for this direction before it animates in.
            const incoming = this.media[i];
            incoming.style.transition = 'none';
            incoming.removeAttribute('data-state');
            void incoming.offsetWidth;
            incoming.style.removeProperty('transition');
            this.media.forEach((m, n) => {
              if (n === i) m.dataset.state = 'active';
              else if (n === prev) m.dataset.state = 'prev';
              else m.removeAttribute('data-state');
              if (Math.abs(n - i) <= 1) this.load(m);
            });
            this.play(this.media[i]);
            this.media.forEach((m, n) => { if (n !== i) this.pause(m); });
            const roll = this.querySelector('[data-roll]');
            if (roll) roll.style.setProperty('--_i', i);
          }
          this.tick();
        }

        tick() {
          this.raf = 0;
          if (!this.classList.contains('is-staged') || this.active < 0) return;
          if (this.lastH !== window.innerHeight || this.lastW !== window.innerWidth) {
            this.lastH = window.innerHeight;
            this.lastW = window.innerWidth;
            this.measure();
          }
          const mid = window.innerHeight / 2;
          const rects = this.reasons.map((r) => r.getBoundingClientRect());
          // The reason under the middle line: the last one whose top is above it (first otherwise).
          let current = 0;
          rects.forEach((rect, n) => { if (rect.top <= mid) current = n; });
          if (current !== this.active) {
            this.activate(current);
            return;
          }
          const ticks = this.querySelectorAll('[data-tick]');
          rects.forEach((rect, n) => {
            const p = Math.min(1, Math.max(0, (mid - rect.top) / rect.height));
            if (n === this.active) this.media[n].style.setProperty('--_p', p.toFixed(3));
            if (ticks[n]) ticks[n].style.setProperty('--_fill', p.toFixed(3));
          });
        }

        // Mobile: wipe each media in as it enters the screen; play videos only while visible.
        reveal() {
          this.classList.add('is-armed');
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const r = entry.target;
              const m = r.querySelector('[data-media]');
              if (entry.isIntersecting) {
                this.load(m);
                r.classList.add('is-in');
                this.play(m);
              } else {
                this.pause(m);
              }
            });
          }, { rootMargin: '0px 0px -15% 0px', threshold: 0.15 });
          this.reasons.forEach((r) => this.io.observe(r));
        }

        // ----- Media loading / playback -----
        defer(m) {
          const img = m.querySelector('img');
          if (!img || img.complete || img.dataset.src) return;
          img.dataset.src = img.getAttribute('src');
          if (img.srcset) img.dataset.srcset = img.getAttribute('srcset');
          img.removeAttribute('srcset');
          img.removeAttribute('src');
        }

        load(m) {
          const img = m && m.querySelector('img');
          if (img && img.dataset.src) {
            if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
            img.setAttribute('src', img.dataset.src);
            delete img.dataset.src;
            delete img.dataset.srcset;
          }
          if (img) img.loading = 'eager';
        }

        play(m) {
          const video = m && m.querySelector('[data-video]');
          if (!video || this.reduced.matches) return;
          if (video.preload === 'none') video.preload = 'auto';
          video.currentTime = 0;
          const p = video.play();
          if (p) p.catch(() => {});
        }

        pause(m) {
          const video = m && m.querySelector('[data-video]');
          if (video && !video.paused) video.pause();
        }

        pauseAll() {
          this.media.forEach((m) => this.pause(m));
        }

        // Reduced motion: GIFs can't be paused, so show their still poster when one is set.
        usePosters() {
          this.querySelectorAll('img[data-poster]').forEach((img) => { img.src = img.dataset.poster; });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-product-offer')) {
    customElements.define(
      'c-product-offer',
      class CProductOffer extends HTMLElement {
        connectedCallback() {
          const notes = this.querySelector(':scope > script[data-notes]');
          this.notes = notes ? JSON.parse(notes.textContent) : [];
          this.panels = [...this.querySelectorAll('[data-panel]')].map((el) => this.setupPanel(el));
          this.onBlockSelect = (e) => {
            const panel = this.panels.find((p) => p.el.contains(e.target));
            if (panel) this.showPanel(panel, null);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          // Other sections preselect an option, e.g. c-color-accordion's "Shop Dune" link:
          // document.dispatchEvent(new CustomEvent('c-product-offer:select', { detail: { option: 'Color', value: 'Dune' } }))
          this.onSelectOption = (e) => this.selectOption(e.detail || {});
          document.addEventListener('c-product-offer:select', this.onSelectOption);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('c-product-offer:select', this.onSelectOption);
          this.panels.forEach((p) => p.ro && p.ro.disconnect());
        }

        selectOption({ option, value }) {
          if (!option || !value) return;
          const name = String(option).toLowerCase().replace(/\s/g, '');
          const wanted = String(value).toLowerCase();
          const p = this.panels.find((x) => !x.el.hidden) || this.panels[0];
          if (!p) return;
          const field = p.fields.find((f) => f.dataset.option.replace(/\s/g, '') === name);
          if (!field) return;
          const select = field.querySelector('[data-option-select]');
          const match = [...select.options].find((o) => o.value.toLowerCase() === wanted);
          if (!match || select.value === match.value) return;
          select.value = match.value;
          select.dispatchEvent(new Event('change'));
        }

        reducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        setupPanel(el) {
          const data = JSON.parse(el.querySelector('script[data-product-json]').textContent);
          const p = {
            el,
            variants: data.variants,
            fields: [...el.querySelectorAll('[data-field]')],
            form: el.querySelector('[data-form]'),
            idInput: el.querySelector('[data-variant-input]'),
            addBtn: el.querySelector('[data-add]'),
            addLabel: el.querySelector('[data-add-label]'),
            status: el.querySelector('[data-status]'),
            price: el.querySelector('[data-price]'),
            compare: el.querySelector('[data-compare]'),
            save: el.querySelector('[data-save]'),
            track: el.querySelector('[data-track]'),
            dots: el.querySelector('[data-dots]'),
            thumbs: [...el.querySelectorAll('[data-thumbs] .c-product-offer__thumb')],
            prev: el.querySelector('.c-product-offer__arrow[data-dir="-1"]'),
            next: el.querySelector('.c-product-offer__arrow[data-dir="1"]'),
          };
          p.idInput.disabled = false;

          p.fields.forEach((field) => {
            field.querySelector('[data-option-select]').addEventListener('change', () => this.refresh(p, true));
          });

          const material = el.querySelector('[data-material]');
          if (material) {
            material.addEventListener('change', () => {
              const target = this.panels.find((x) => x.el.dataset.productId === material.value);
              material.value = el.dataset.productId;
              if (target) this.showPanel(target, p);
            });
          }

          el.querySelectorAll('[data-qty]').forEach((btn) => btn.addEventListener('click', () => {
            const input = el.querySelector('[data-qty-input]');
            input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty)));
          }));

          // With JS the button no longer submits: cart apps (Rebuy) also catch /cart/add submits and
          // would add the item a second time. The native submit stays as the no-JS fallback.
          p.addBtn.type = 'button';
          p.addBtn.removeAttribute('name');
          p.addBtn.addEventListener('click', () => this.add(p));
          p.form.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.add(p);
          });

          // Gallery: arrows, thumbs and dots all scroll the track; the scroll position drives state.
          [p.prev, p.next].forEach((btn) => btn.addEventListener('click', () => {
            if (btn.getAttribute('aria-disabled') === 'true') return;
            this.goTo(p, this.activeIndex(p) + Number(btn.dataset.dir));
          }));
          p.thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
            const i = this.visibleSlides(p).findIndex((s) => s.dataset.mediaId === thumb.dataset.mediaId);
            if (i > -1) this.goTo(p, i);
          }));
          p.raf = 0;
          p.track.addEventListener('scroll', () => {
            cancelAnimationFrame(p.raf);
            p.raf = requestAnimationFrame(() => this.syncGallery(p));
          }, { passive: true });
          p.ro = new ResizeObserver(() => this.syncGallery(p));
          p.ro.observe(p.track);

          this.buildDots(p);
          this.refresh(p, false);
          return p;
        }

        showPanel(target, from) {
          if (from) {
            // Carry the shopper's choices over when the sibling product has the same option values.
            from.fields.forEach((field) => {
              const value = field.querySelector('[data-option-select]').value;
              const twin = target.fields.find((f) => f.dataset.option === field.dataset.option);
              if (!twin) return;
              const select = twin.querySelector('[data-option-select]');
              if ([...select.options].some((o) => o.value === value)) select.value = value;
            });
            const qty = from.el.querySelector('[data-qty-input]').value;
            target.el.querySelector('[data-qty-input]').value = qty;
          }
          this.panels.forEach((p) => { p.el.hidden = p !== target; });
          this.refresh(target, true);
          const material = target.el.querySelector('[data-material]');
          if (from && material) material.focus({ preventScroll: true });
        }

        selected(p) {
          return p.fields.map((f) => ({ pos: Number(f.dataset.position), value: f.querySelector('[data-option-select]').value }));
        }

        match(p) {
          const sel = this.selected(p);
          return p.variants.find((v) => sel.every((s) => v.options[s.pos - 1] === s.value)) || null;
        }

        refresh(p, updateMedia) {
          const sel = this.selected(p);
          p.fields.forEach((field) => {
            const pos = Number(field.dataset.position);
            const select = field.querySelector('[data-option-select]');
            const others = sel.filter((s) => s.pos !== pos);
            [...select.options].forEach((opt) => {
              const possible = p.variants.some((v) => v.available && v.options[pos - 1] === opt.value && others.every((s) => v.options[s.pos - 1] === s.value));
              opt.textContent = possible ? opt.value : `${opt.value} (sold out)`;
            });
            const swatch = field.querySelector('[data-swatch]');
            if (swatch) swatch.dataset.swatch = select.value.toLowerCase();
            const noteEl = field.querySelector('[data-note]');
            if (noteEl) {
              const option = field.dataset.option;
              const hit = [...this.notes].reverse().find((n) => n.option === option && (!n.value || n.value === select.value));
              noteEl.textContent = hit ? hit.note : '';
            }
          });

          const variant = this.match(p);
          const available = Boolean(variant && variant.available);
          if (variant) {
            p.idInput.value = variant.id;
            p.price.textContent = variant.price;
            p.compare.hidden = !variant.compare;
            p.save.hidden = !variant.compare;
            if (variant.compare) {
              p.compare.querySelector('[data-compare-value]').textContent = variant.compare;
              p.save.textContent = `${variant.save}% off`;
            }
          }
          p.addBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
          p.addLabel.textContent = available ? this.dataset.addLabel : this.dataset.soldOut;
          if (updateMedia && variant && variant.media) this.showGroup(p, String(variant.media));
        }

        // ----- Gallery -----
        visibleSlides(p) {
          return [...p.track.children].filter((s) => !s.hidden);
        }

        showGroup(p, group) {
          const slides = [...p.track.children];
          if (!slides.some((s) => s.dataset.group === group)) return;
          slides.forEach((s) => { s.hidden = s.dataset.group !== group; });
          p.thumbs.forEach((t) => { t.parentElement.hidden = t.parentElement.dataset.group !== group; });
          p.track.scrollLeft = 0;
          this.buildDots(p);
          this.syncGallery(p);
        }

        activeIndex(p) {
          const w = p.track.clientWidth || 1;
          return Math.round(p.track.scrollLeft / w);
        }

        goTo(p, i) {
          const slides = this.visibleSlides(p);
          const index = Math.max(0, Math.min(slides.length - 1, i));
          p.track.scrollTo({ left: index * p.track.clientWidth, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
        }

        buildDots(p) {
          if (!p.dots) return;
          p.dots.textContent = '';
          const slides = this.visibleSlides(p);
          if (slides.length < 2) return;
          slides.forEach((s, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'c-product-offer__dot';
            dot.setAttribute('aria-label', `Show image ${i + 1} of ${slides.length}`);
            dot.addEventListener('click', () => this.goTo(p, i));
            p.dots.appendChild(dot);
          });
        }

        syncGallery(p) {
          const slides = this.visibleSlides(p);
          const i = this.activeIndex(p);
          const current = slides[i];
          p.prev.setAttribute('aria-disabled', i <= 0 ? 'true' : 'false');
          p.next.setAttribute('aria-disabled', i >= slides.length - 1 ? 'true' : 'false');
          [...p.dots.children].forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
          p.thumbs.forEach((t) => t.setAttribute('aria-current', current && t.dataset.mediaId === current.dataset.mediaId ? 'true' : 'false'));
        }

        // ----- Cart -----
        async add(p) {
          const variant = this.match(p);
          if (!variant || !variant.available || p.el.hasAttribute('data-busy')) return;
          const quantity = Math.max(1, parseInt(p.el.querySelector('[data-qty-input]').value, 10) || 1);
          p.el.setAttribute('data-busy', '');
          p.status.textContent = '';
          const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
          try {
            const res = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity }] }),
            });
            const body = await res.json();
            if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
            p.status.textContent = 'Added to cart';
            if (await this.openRebuyCart()) return;
            if (this.dataset.cartType === 'page') {
              window.location.href = `${root}cart`;
              return;
            }
            document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
          } catch (err) {
            p.status.textContent = err.message;
            console.error('[c-product-offer]', err);
          } finally {
            p.el.removeAttribute('data-busy');
          }
        }

        // Same as c-quick-shop: Rebuy Smart Cart is the store's cart drawer.
        async openRebuyCart() {
          const rebuy = window.Rebuy;
          if (!rebuy || !rebuy.SmartCart || !rebuy.Cart) return false;
          try {
            await rebuy.Cart.fetchCart();
            rebuy.SmartCart.show();
            return true;
          } catch (err) {
            console.error('[rebuy]', err);
            return false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-product-rail')) {
    customElements.define(
      'c-product-rail',
      class CProductRail extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 };
              if (!(e.key in map)) return;
              e.preventDefault();
              const next = (map[e.key] + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });

          this.querySelectorAll('.c-product-rail__panel').forEach((panel) => this.bindPanel(panel));

          document.addEventListener('shopify:block:select', (e) => {
            const i = this.tabs.findIndex((t) => t === e.target || t.contains(e.target));
            if (i > -1) this.select(i);
          });
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
            if (panel) {
              panel.hidden = !on;
              if (on) {
                panel.querySelectorAll('img[loading="lazy"]').forEach((img, n) => { if (n < 4) img.loading = 'eager'; });
                const track = panel.querySelector('[data-track]');
                if (track) { track.scrollLeft = 0; this.update(panel); }
              }
            }
          });
        }

        bindPanel(panel) {
          const track = panel.querySelector('[data-track]');
          if (!track) return;
          const dots = panel.querySelector('[data-dots]');
          const items = [...track.children];
          if (dots) {
            items.forEach((item, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'c-product-rail__dot';
              dot.setAttribute('aria-label', `Go to product ${i + 1} of ${items.length}`);
              dot.addEventListener('click', () => this.scrollToItem(track, item));
              dots.appendChild(dot);
            });
          }
          panel.querySelectorAll('[data-dir]').forEach((btn) => {
            btn.addEventListener('click', () => {
              if (btn.getAttribute('aria-disabled') === 'true') return;
              const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth * 0.6, behavior: smooth ? 'smooth' : 'auto' });
            });
          });
          let raf = 0;
          const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => this.update(panel)); };
          track.addEventListener('scroll', schedule, { passive: true });
          new ResizeObserver(schedule).observe(track);
          schedule();
        }

        scrollToItem(track, item) {
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: item.offsetLeft - track.firstElementChild.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        }

        update(panel) {
          const track = panel.querySelector('[data-track]');
          if (!track) return;
          const max = track.scrollWidth - track.clientWidth;
          const prev = panel.querySelector('[data-dir="-1"]');
          const next = panel.querySelector('[data-dir="1"]');
          const setState = (btn, off) => {
            if (!btn) return;
            btn.setAttribute('aria-disabled', off ? 'true' : 'false');
            btn.tabIndex = off ? -1 : 0;
          };
          setState(prev, track.scrollLeft <= 4);
          setState(next, max <= 4 || track.scrollLeft >= max - 4);
          const dots = panel.querySelectorAll('.c-product-rail__dot');
          if (dots.length) {
            const items = [...track.children];
            const start = track.firstElementChild.offsetLeft;
            let active = 0;
            items.forEach((item, i) => { if (item.offsetLeft - start <= track.scrollLeft + 10) active = i; });
            if (track.scrollLeft >= max - 4) active = items.length - 1;
            dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-review-wall"] && !Shopify.designMode) return;
  try {
    
  // Scroll-linked rail: on desktop (>=978px) with motion allowed, the rail pins (position: sticky)
  // as it enters the viewport and the extra scroll distance translates the track left 1:1 with
  // scroll position — reversing exactly on scroll-up, never looping. On mobile, reduced motion, or
  // before this upgrades, it's a plain swipeable scroll-snap rail (base CSS), optionally starting
  // centered like the Figma composition.
  class ReviewRail extends HTMLElement {
    connectedCallback() {
      this.sticky = this.querySelector('[data-sticky]');
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.active = false;
      this._ticking = false;
      this._onScroll = () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this._ticking = false;
        });
      };
      this._onResize = () => {
        this.placeMobileFirst();
        this.measure();
        this.centerIfNeeded();
        this.update();
      };

      this.placeMobileFirst();
      this.measure();
      this.centerIfNeeded();
      this.update();
      this.setupControls();

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      document.addEventListener('shopify:section:load', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('shopify:section:load', this._onResize);
    }

    measure() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isDesktop = window.innerWidth >= 978;

      if (reduced || !isDesktop) {
        this.active = false;
        this.classList.remove('is-pinned');
        this.style.height = '';
        this.track.style.transform = '';
        return;
      }

      // Center the pin point in the room below the header (like c-listicle's stage), so the rail
      // catches roughly mid-screen instead of right under the header — leaving the heading above
      // it visible instead of getting pushed off immediately.
      const header = document.querySelector('.section-header');
      const headerH = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
      const room = window.innerHeight - headerH;
      const stickyH = this.sticky.offsetHeight;
      const stageTop = headerH + Math.max(24, (room - stickyH) / 2);
      this.style.setProperty('--_stage-top', `${stageTop}px`);
      this.classList.add('is-pinned');

      const overflow = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
      this._overflow = overflow;
      this.active = overflow > 0;
      this.style.height = overflow > 0 ? `${stickyH + overflow}px` : '';
      if (!this.active) this.track.style.transform = '';
    }

    update() {
      if (!this.active) return;
      const rect = this.getBoundingClientRect();
      const stageTop = parseFloat(getComputedStyle(this).getPropertyValue('--_stage-top')) || 0;
      const raw = stageTop - rect.top;
      const progress = Math.min(1, Math.max(0, raw / this._overflow));
      this.track.style.transform = `translateX(-${(progress * this._overflow).toFixed(2)}px)`;
    }

    // "Start with a review on mobile": CSS order alone isn't enough — Safari's scroll-snap anchors
    // to the first column in DOM order and opens the rail on the photo. So on mobile the column is
    // moved to the front of the DOM, and back to its spot (marked by a comment) on desktop.
    placeMobileFirst() {
      const col = this.track.querySelector('.c-review-wall__col--mobile-first');
      if (!col) return;
      if (!this._mobileFirstMark) {
        this._mobileFirstMark = document.createComment('mobile-first');
        col.before(this._mobileFirstMark);
      }
      const mobile = window.innerWidth < 978;
      if (mobile && this.track.firstElementChild !== col) {
        this.track.prepend(col);
        this.track.scrollLeft = 0;
      } else if (!mobile && this._mobileFirstMark.nextSibling !== col) {
        this._mobileFirstMark.after(col);
      }
    }

    // Mobile dots + arrows for the swipeable rail: one dot per column, in on-screen order (a column
    // can be moved to the front with CSS order, so sort by position rather than DOM order).
    setupControls() {
      const controls = this.querySelector('[data-controls]');
      if (!controls) return;
      this.dotsEl = controls.querySelector('[data-dots]');
      this.arrows = [...controls.querySelectorAll('[data-step]')];
      this.cols = () => [...this.track.querySelectorAll('[data-col]')].sort((a, b) => a.offsetLeft - b.offsetLeft);

      this.dots = this.cols().map((col, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'c-review-wall__dot';
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsEl.appendChild(dot);
        return dot;
      });
      this.arrows.forEach((btn) => btn.addEventListener('click', () => this.goTo(this.current() + Number(btn.dataset.step))));

      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { this.syncControls(); ticking = false; });
      }, { passive: true });
      this.syncControls();
    }

    current() {
      const cols = this.cols();
      const start = cols[0] ? cols[0].offsetLeft : 0;
      const x = this.track.scrollLeft;
      let best = 0;
      cols.forEach((col, i) => { if (Math.abs(col.offsetLeft - start - x) < Math.abs(cols[best].offsetLeft - start - x)) best = i; });
      // At the end of the rail the last few columns can't reach the snap edge; count that as the last.
      if (x >= this.track.scrollWidth - this.track.clientWidth - 2) best = cols.length - 1;
      return best;
    }

    goTo(index) {
      const cols = this.cols();
      const i = Math.max(0, Math.min(cols.length - 1, index));
      this.track.scrollTo({ left: cols[i].offsetLeft - cols[0].offsetLeft, behavior: 'smooth' });
    }

    syncControls() {
      if (!this.dots) return;
      const i = this.current();
      this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
      this.arrows[0].disabled = i === 0;
      this.arrows[1].disabled = i === this.dots.length - 1;
    }

    centerIfNeeded() {
      if (this.active || !this.hasAttribute('data-center-start') || this.dataset.centered) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 0) return;
      this.dataset.centered = 'true';
      this.track.scrollLeft = max / 2;
    }
  }

  if (!customElements.get('c-review-rail')) {
    customElements.define('c-review-rail', ReviewRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-stats-count')) {
    customElements.define(
      'c-stats-count',
      class CStatsCount extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          // "60 sec" -> prefix "", number 60, suffix " sec". Values without a number stay as they are.
          this.items = [...this.querySelectorAll('[data-count]')]
            .map((el) => {
              const match = el.textContent.trim().match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
              if (!match) return null;
              const decimals = (match[2].split('.')[1] || '').length;
              return { el, prefix: match[1], target: parseFloat(match[2]), suffix: match[3], decimals };
            })
            .filter(Boolean);
          if (!this.items.length) return;

          this.items.forEach((item) => this.render(item, 0));
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.io.disconnect();
              this.run();
            },
            { threshold: 0.4 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        render(item, value) {
          item.el.textContent = item.prefix + value.toFixed(item.decimals) + item.suffix;
        }

        // Ease-out count over ~1.4s, each stat starting 120ms after the previous one.
        run() {
          const duration = 1400;
          const stagger = 120;
          const start = performance.now();
          const tick = (now) => {
            let done = true;
            this.items.forEach((item, i) => {
              const t = Math.min(1, Math.max(0, (now - start - i * stagger) / duration));
              if (t < 1) done = false;
              this.render(item, item.target * (1 - Math.pow(1 - t, 3)));
            });
            if (!done) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-testimonials')) {
    customElements.define(
      'c-testimonials',
      class CTestimonials extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.c-testimonials__slide')];
          this.dots = [...this.querySelectorAll('.c-testimonials__dot')];
          this.list = this.querySelector('.c-testimonials__slides');
          if (this.slides.length < 2) return;
          this.index = 0;
          this.held = false;
          this.interval = parseInt(this.dataset.interval, 10) || 0;
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.list.setAttribute('aria-live', 'polite'); this.show(i); this.start(); }));
          this.addEventListener('mouseenter', () => { this.held = true; });
          this.addEventListener('mouseleave', () => { this.held = false; });
          this.addEventListener('focusin', () => { this.held = true; });
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.held = false; });
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1) { this.held = true; this.show(i); }
          });
          document.addEventListener('shopify:block:deselect', () => { this.held = false; });
          this.start();
        }

        disconnectedCallback() { clearInterval(this.timer); }

        start() {
          clearInterval(this.timer);
          if (!this.interval) return;
          this.timer = setInterval(() => {
            if (!this.held && !document.hidden) this.show((this.index + 1) % this.slides.length);
          }, this.interval);
        }

        show(i) {
          this.index = i;
          this.slides.forEach((s, n) => s.toggleAttribute('data-active', n === i));
          this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-versus"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-versus-count')) {
    customElements.define(
      'c-versus-count',
      class CVersusCount extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.items = [...this.querySelectorAll('[data-count]')]
            .map((el) => ({ el, target: parseFloat(el.textContent) }))
            .filter((item) => !Number.isNaN(item.target));
          if (!this.items.length) return;

          // Each number keeps the width of its final value (tabular digits), so the row doesn't
          // shift while counting; the digits grow from the unit outward.
          this.items.forEach((item) => {
            item.el.style.display = 'inline-block';
            item.el.style.minWidth = `${item.el.textContent.trim().length}ch`;
            item.el.style.textAlign = 'end';
            item.el.textContent = '0';
          });
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.io.disconnect();
              this.run();
            },
            { threshold: 0.4 }
          );
          // This element is display: contents (no box of its own), so watch the row.
          this.io.observe(this.firstElementChild || this.parentElement);
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        // Ease-out count over ~1.4s, the second side starting 120ms after the first.
        run() {
          const duration = 1400;
          const stagger = 120;
          const start = performance.now();
          const tick = (now) => {
            let done = true;
            this.items.forEach((item, i) => {
              const t = Math.min(1, Math.max(0, (now - start - i * stagger) / duration));
              if (t < 1) done = false;
              item.el.textContent = Math.round(item.target * (1 - Math.pow(1 - t, 3)));
            });
            if (!done) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-video-carousel')) {
    customElements.define(
      'c-video-carousel',
      class CVideoCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.originals = [...this.track.children];
          this.count = this.originals.length;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Loop: one copy of the set on each side, so wide screens are always filled.
          // Copies are hidden from assistive tech; landing on one jumps to its original.
          this.offset = 0;
          if (this.count > 1) {
            const copy = (card) => {
              const c = card.cloneNode(true);
              c.setAttribute('aria-hidden', 'true');
              c.removeAttribute('data-active');
              c.removeAttribute('data-shopify-editor-block');
              c.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
              c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
              c.querySelectorAll('[aria-controls]').forEach((el) => el.removeAttribute('aria-controls'));
              return c;
            };
            this.track.prepend(...this.originals.map(copy));
            this.track.append(...this.originals.map(copy));
            this.offset = this.count;
          }
          this.cards = [...this.track.children];

          // Start with the configured card centered, without animating.
          const start = this.offset + Math.min(Number(this.dataset.start) || 0, this.count - 1);
          requestAnimationFrame(() => { this.center(start, 'auto'); this.setActive(start); });

          this.cards.forEach((card, i) => card.addEventListener('click', (e) => {
            if (card.hasAttribute('data-active') || e.target.closest('a, button, c-quick-shop')) return;
            this.center(i, this.reduced ? 'auto' : 'smooth');
          }));

          // "+" opens that card's quick shop (and brings the card to the center); one panel at a time.
          this.cards.forEach((card, i) => {
            const btn = card.querySelector('[data-quick-shop-open]');
            const panel = card.querySelector('c-quick-shop');
            if (!btn || !panel) return;
            btn.addEventListener('click', () => {
              if (!panel.hidden) { panel.close(); return; }
              this.closePanels(panel);
              if (!card.hasAttribute('data-active')) this.center(i, this.reduced ? 'auto' : 'smooth');
              panel.open(btn);
            });
          });

          let raf = 0;
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => this.setActive(this.closest()));
            clearTimeout(this.settle);
            this.settle = setTimeout(() => { this.wrap(); this.closePanels(null, true); }, 160);
          }, { passive: true });

          // Play only what is on screen (and nothing with reduced motion).
          this.io = new IntersectionObserver((entries) => entries.forEach((en) => {
            const v = en.target.querySelector('video');
            if (!v) return;
            if (en.isIntersecting && !this.reduced) { v.play().catch(() => {}); } else { v.pause(); }
          }), { threshold: 0.25 });
          this.cards.forEach((c) => this.io.observe(c));

          document.addEventListener('shopify:block:select', (e) => {
            const i = this.originals.indexOf(e.target);
            if (i > -1) this.center(this.offset + i, 'auto');
          });
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          clearTimeout(this.settle);
        }

        center(i, behavior) {
          const card = this.cards[i];
          const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
          this.track.scrollTo({ left, behavior });
        }

        // After scrolling stops on a copy, jump (no animation) to the same card in the original set.
        wrap() {
          if (!this.offset) return;
          const i = this.closest();
          if (i >= this.offset && i < this.offset + this.count) return;
          const target = this.offset + (((i - this.offset) % this.count) + this.count) % this.count;
          const shift = this.cards[target].offsetLeft - this.cards[i].offsetLeft;
          this.track.setAttribute('data-jumping', '');
          this.track.scrollTo({ left: this.track.scrollLeft + shift, behavior: 'auto' });
          this.setActive(target);
          requestAnimationFrame(() => requestAnimationFrame(() => this.track.removeAttribute('data-jumping')));
        }

        // Close open quick shops, except `keep`; with `inactiveOnly`, only those outside the centered card.
        closePanels(keep, inactiveOnly) {
          this.track.querySelectorAll('c-quick-shop:not([hidden])').forEach((p) => {
            if (p === keep) return;
            if (inactiveOnly && p.closest('[data-active]')) return;
            p.close();
          });
        }

        closest() {
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0, dist = Infinity;
          this.cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < dist) { dist = d; best = i; } });
          return best;
        }

        setActive(i) {
          this.cards.forEach((c, n) => c.toggleAttribute('data-active', n === i));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-word-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c-word-switcher')) {
    customElements.define(
      'c-word-switcher',
      class CWordSwitcher extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          if (!this.tabs.length) return;
          this.active = 0;
          this.held = false;
          this.interval = parseInt(this.dataset.interval, 10) || 0;

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.show(i, true));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });

          const hold = () => { this.held = true; };
          const release = () => { this.held = false; };
          this.addEventListener('mouseenter', hold);
          this.addEventListener('mouseleave', release);
          this.addEventListener('focusin', hold);
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) release(); });

          this.show(0, false);
          this.start();

          document.addEventListener('shopify:block:select', (e) => {
            const i = this.tabs.findIndex((t) => t.contains(e.target));
            if (i > -1) { this.held = true; this.show(i, false); }
          });
          document.addEventListener('shopify:block:deselect', () => { this.held = false; });
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        start() {
          clearInterval(this.timer);
          if (!this.interval || this.tabs.length < 2) return;
          this.timer = setInterval(() => {
            if (!this.held && !document.hidden) this.show((this.active + 1) % this.tabs.length, false);
          }, this.interval);
        }

        onKey(e, i) {
          const last = this.tabs.length - 1;
          const map = { ArrowDown: i + 1, ArrowRight: i + 1, ArrowUp: i - 1, ArrowLeft: i - 1, Home: 0, End: last };
          if (!(e.key in map)) return;
          e.preventDefault();
          const next = (map[e.key] + this.tabs.length) % this.tabs.length;
          this.show(next, true);
          this.tabs[next].focus();
        }

        show(index, byUser) {
          this.active = index;
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
          });
          this.querySelectorAll('.c-word-switcher__image, .c-word-switcher__copy').forEach((el) => {
            el.dataset.state = Number(el.dataset.index) === index ? 'active' : 'inactive';
          });
          const next = this.querySelector(`.c-word-switcher__image[data-index="${(index + 1) % this.tabs.length}"] img`);
          if (next) next.loading = 'eager';
          if (byUser) this.start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
